module.exports = __webpack_public_path__ + "static/nginrNews1-b9cdc5638b80188799f20501f1986931.png";